import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { SignalState } from '@shared-ikp/service/signal-state-service/signal-state.service';
import { FormsModule } from '@angular/forms';
import { MeterPointChangeSignalState } from '../../../../../meterpoint-change-request.types';
import { InfoTooltipComponent } from '@shared-ikp/components/info-tooltip/info-tooltip.component';
import { ContractPartnerEmpty, VertragspartnerSelectionType } from '../../../../new-contract-partner.utils';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'ikp-vertragspartner-type-selection',
  standalone: true,
  imports: [FormsModule, InfoTooltipComponent, TranslatePipe],
  templateUrl: './vertragspartner-type-selection.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VertragspartnerTypeSelectionComponent {
  protected wizardStore: MeterPointChangeSignalState = inject(SignalState);

  protected vertriebsPartnerSelection = computed(
    () => this.wizardStore.state().newContractPartner?.vertragspartnerSelection ?? VertragspartnerSelectionType.EIGENES_UNTERNEHMEN,
  );

  protected onSelectionChange(selection: VertragspartnerSelectionType): void {
    this.wizardStore.patchState({
      newContractPartner: {
        ...this.wizardStore.state().newContractPartner,
        vertragspartnerSelection: selection,
        emptyPartner: this.buildEmptyPartnerInfo(selection),
        alternativeInvoicingAddress: null,
      },
    });
  }

  private buildEmptyPartnerInfo(selection: VertragspartnerSelectionType): ContractPartnerEmpty {
    if (selection === VertragspartnerSelectionType.ALTERNATIVE_PARTNER) {
      return { name: null, address: null, gpNr: null, uid: null, phone: null, email: null };
    }

    const { name, address, gpNr, uid } = this.wizardStore.state().newContractPartner.currentCompanyInfo;
    return {
      name,
      gpNr,
      uid,
      address: {
        street: address.street,
        houseNumberStaircase: address.streetNumber,
        door: address.doorNumber,
        plz: address.postcode,
        city: address.city,
      },
    };
  }

  protected readonly VertragspartnerSelectionType = VertragspartnerSelectionType;
}
